import styles from "./PageDivider.module.scss";

export const PageDivider = (props) => {
  const { color, style } = props;
  let dividerStyle = color ? { color, backgroundColor: color } : {};
  if (style) {
    dividerStyle = { ...style, ...dividerStyle };
  }
  return (
    <hr id={props.id} style={dividerStyle} className={`${styles.PageDivider} ${props.className ? props.className : ''}`} />
  );
};

export default PageDivider;
